export class RecipientModel {
  public id: Number;
  public tipoPersona: String;
  public nombre: String;
  public cvuCbu: String;
  public alias: String;

  constructor(id: Number, tipoPersona: String, nombre: String, cvuCbu?: String, alias?: String) {
    this.id = id;
    this.tipoPersona = tipoPersona;
    this.nombre = nombre;
    this.cvuCbu = cvuCbu;
    this.alias = alias;
  }
}
